
// SCSS
import '~/assets/scss/only-base.scss'

// JS
import '~/js/helpers/polyfills'
import '~/js/helpers/svg-sprite'
import '~/js/helpers/css-props'
import '~/js/modules/simple-dropdown'
import '~/pug/blocks/header/header'
import '~/pug/blocks/modal/modal'
import '~/pug/blocks/form/form'
import '~/pug/blocks/telephone/telephone'
import '~/pug/blocks/top-basket/top-basket'
import '~/pug/blocks/top-compare/top-compare'
import store from '~/js/store'


// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
;(function() {
  if (typeof window.CustomEvent === "function") return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent("CustomEvent")
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

store.dispatch('loadProductsInBasket')
store.dispatch('loadCompareIds')

window.addToCompare = function addToCompare(productId) {
  store.dispatch('addToCompare', parseInt(productId))
}

window.addToBasket = function addToCompare(productId) {
  store.dispatch('addToBasket', {id:productId, quantity: 1})
}

window.showPriceGetPopup = function showPriceGetPopup(productId) {
  let event = new CustomEvent('showModal', {
    detail: {
      formId: 9,
      productId: productId
    }
  })
  document.dispatchEvent(event)
}
